import React from 'react'

function Error503() {
  return (
    <main>
        <div class="error-container p-0">
    <div class="container">
        <div>
            <div>
                <img alt="" class="img-fluid" src="../assets/images/background/error-503.png"/>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <p class="text-center text-secondary f-w-500">503 status code (Service Unavailable) typically
                            indicates a performance issue on the origin server.</p>
                    </div>
                </div>
            </div>
            <a class="btn btn-lg btn-light-danger b-r-22" href="/" role="button"><i class="iconoir-home-simple"></i>
                Back To
                Home</a>
        </div>
    </div>
</div>
    </main>
  )
}

export default Error503